<div class="dm-flex dm-flex-column dm-items-center dm-gap-2">
  @if (iconName(); as icon) {
    <dm-icon class="lp-verlauf-timeline-group__icon" size="sm" theme="modern" color="gray" [featured]="true" [name]="icon" />
  } @else {
    <dm-avatar size="sm" [lpAvatarFromPerson]="group().author" />
  }
  @if (!isLast()) {
    <span class="lp-verlauf-timeline-group__connector"></span>
  }
</div>

<div class="lp-verlauf-timeline-group__body dm-min-w-0">
  <!-- One author and one date over the parts of one save, inset to meet the marker. -->
  <div class="dm-flex dm-flex-wrap dm-items-center dm-gap-6 dm-padding-top-4 dm-margin-bottom-4">
    @if (showsAuthorAvatar()) {
      <dm-avatar size="xs" [lpAvatarFromPerson]="group().author" />
    }
    @if (authorName(); as authorName) {
      <span class="dm-text-sm dm-text-weight-medium dm-color-text-primary">{{ authorName }}</span>
    }
    @if (timestampLabel(); as label) {
      @if (authorName()) {
        <span class="dm-text-sm dm-color-text-quaternary">·</span>
      }
      <span class="dm-text-sm dm-color-text-quaternary">{{ label }}</span>
    }
  </div>
  <div class="lp-verlauf-timeline-group__parts">
    <ng-content />
  </div>
</div>
